import { useEffect, useState } from "react";
import { Flame } from "lucide-react";

/**
 * FirstDeathRescueBanner (iter67.5) — fired ONCE in a user's lifetime,
 * when their very first run-ending death is auto-rescued by the Ember.
 * Converts a would-be D0 rage-quit into a hook: "the realm wants you alive."
 *
 * Lives for ~6 seconds then auto-dismisses. Shows briefly over the dashboard.
 */
export default function FirstDeathRescueBanner({ visible, message, onClose }) {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (!visible) return;
    setOpen(true);
    const t = setTimeout(() => {
      setOpen(false);
      onClose && onClose();
    }, 6500);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible]);

  if (!open || !visible) return null;

  return (
    <div
      className="fixed inset-x-0 top-6 z-[80] flex items-start justify-center px-4 pointer-events-none"
      data-testid="first-death-rescue-banner"
    >
      <div
        className="panel p-5 max-w-lg w-full flex items-start gap-4 pointer-events-auto fade-up"
        style={{
          background: "radial-gradient(ellipse at top, rgba(226,88,34,0.35), rgba(10,5,3,0.98))",
          borderColor: "#e25822",
          boxShadow: "0 0 50px rgba(226,88,34,0.6), inset 0 0 30px rgba(226,88,34,0.15)",
        }}
      >
        <div
          className="flex-shrink-0 rounded-full p-2.5"
          style={{
            background: "rgba(226,88,34,0.25)",
            boxShadow: "0 0 20px rgba(226,88,34,0.55)",
          }}
        >
          <Flame size={22} style={{ color: "#ffb56b" }} />
        </div>
        <div className="flex-1">
          <div className="text-[10px] tracking-[0.5em]" style={{ color: "#ffb56b" }}>
            THE EMBER · INTERVENES
          </div>
          <div className="font-heading text-xl text-[#f0e6d2] italic mt-1 leading-snug">
            {message || "The Ember stirs. It will not let you fall — not yet."}
          </div>
          <div className="text-[10px] tracking-widest ash-text mt-2 opacity-80">
            This gift fires once per hero. The next death is final.
          </div>
        </div>
        <button
          type="button"
          onClick={() => { setOpen(false); onClose && onClose(); }}
          className="text-[10px] tracking-widest ash-text hover:text-[#f0e6d2] self-start"
          data-testid="first-death-rescue-close"
        >
          ×
        </button>
      </div>
    </div>
  );
}
